<div class="signin-wrapper">
    <div class="app-logo">
        <img src="assets/img/app-logo.svg" alt="App Logo">
    </div>

    <div class="container">
        <h1 class="h3 mb-4" *ngIf="isSubscribe && isSuccess">{{ 'AUTHORIZATION.UPDATED_PASSWORD_CHECK_MAIL' | translate }}</h1>
        <h1 class="h3 mb-4" *ngIf="isSubscribe && !isSuccess">{{ 'AUTHORIZATION.PASSWORD_UPDATE_ERROR' | translate }}</h1>

    </div>
</div>